import Modal from '../../components/Feedback/Modal';
import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../library/helpers/rtl';

const TopbarSearchModal = styled(Modal)`
  &.ant-modal {
    top: 150px;
    padding-bottom: 0;
  }

  .ant-modal-close-x {
    width: 28px;
    height: 28px;
    line-height: 28px;
    display: none;
  }

  .ant-modal-content {
    overflow: hidden;
    border-radius: 5px;

    .ant-modal-header {
      display: none;
    }

    .ant-modal-body {
      padding: 0px;

      .isoSearchContainer {
        .ant-input-search {
          position: relative;
          border: 0;
          border-radius: 0;
          padding-left: ${(props) =>
            props['data-rtl'] === 'rtl' ? '15px' : '55px'};
          padding-right: ${(props) =>
            props['data-rtl'] === 'rtl' ? '55px' : '15px'};
          height: 60px;
          max-height: none;

          .ant-input {
            font-size: 14px;

            &::-webkit-input-placeholder {
              color: ${palette('grayscale', 0)};
            }

            &:-moz-placeholder {
              color: ${palette('grayscale', 0)};
            }

            &::-moz-placeholder {
              color: ${palette('grayscale', 0)};
            }
            &:-ms-input-placeholder {
              color: ${palette('grayscale', 0)};
            }

            &:focus {
              outline: 0;
              box-shadow: none;
            }
          }

          .ant-input-prefix {
            right: ${(props) =>
              props['data-rtl'] === 'rtl' ? '20px' : 'auto'};
            left: ${(props) => (props['data-rtl'] === 'rtl' ? 'auto' : '20px')};
            height: 0;
            position: absolute;
            top: 50%;

            svg {
              color: ${palette('text', 2)};
            }
          }
        }

        .ant-input-suffix {
          .ant-input-search-icon {
            display: none;
          }
        }
      }
    }
  }
`;

export default WithDirection(TopbarSearchModal);
